import { Component, OnInit, TemplateRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Observable, of, Subject, throwError } from "rxjs";
import { catchError, debounceTime, distinctUntilChanged, retry, switchMap } from "rxjs/operators";
import { NzMessageService } from "ng-zorro-antd/message";

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthenticationService } from "@app/_services";

import { ErrorMessages, User } from "@app/_models";
import { Files } from "@app/_models";
import { Process } from "@app/_models";
import { ApiBackendService } from "@app/_services/api-backend.service";
import { environment } from "../../../../environments/environment";
import { AngularFireStorage } from "@angular/fire/compat/storage";
import { NzModalService } from "ng-zorro-antd/modal";
import { Globals } from "@app/_helpers";

@Component({
  selector: "app-files",
  templateUrl: "files.component.html",
  styleUrls: ["files.component.css"],
})
export class FilesComponent implements OnInit {
  apiUrl = null;
  files: Observable<Files[]>;
  process: Observable<Process[]>;
  public filesData: any = [];
  loading = true;
  userRole = null;
  totalBalante = 0;
  showSelectUser = undefined;
  showEditNotes = undefined;
  selectedUser: string;
  notes: string;
  listOfUsers: Array<{
    label: string;
    value: number;
    firstName: string;
    lastName: string;
  }> = [];
  finalListOfUsers: Array<{
    label: string;
    value: number;
    firstName: string;
    lastName: string;
  }> = [];
  selectedUserDetails: any;
  pageIndex = 1;
  totalPages = 1;
  pageSize = 10;
  currentUser: User;
  currentUserInfo = null;
  frontendUploadUrl = environment.frontendUrl + "/upload";
  months = {
    1: "Ian",
    2: "Feb",
    3: "Mar",
    4: "Apr",
    5: "Mai",
    6: "Iun",
    7: "Iul",
    8: "Aug",
    9: "Sep",
    10: "Oct",
    11: "Noi",
    12: "Dec",
  };
  fullMonths = {
    1: "Ianuarie",
    2: "Februarie",
    3: "Martie",
    4: "Aprilie",
    5: "Mai",
    6: "Iunie",
    7: "Iulie",
    8: "August",
    9: "Septembrie",
    10: "Octombrie",
    11: "Noiembrie",
    12: "Decembrie",
  };
  downloadURL: Observable<any>;
  fileMarkedForDownload;
  errorMessages: ErrorMessages[];
  x;

  public filesDataToDisplay: any = [];
  searchValueBalante = "";
  searchValueMessage = "";
  searchValueName = "";
  searchValueProcessedName = "";
  searchValueEmail = "";
  searchValueDate = "";
  searchUploadDate = "";
  searchValueNotite = "";
  infoFile: any = null;
  checkCompare = [];
  unlimitedSubscription = false;
  subscriptionEndDate = null;

  private searchSubject = new Subject<string>();
  isLoading = false;

  constructor(private authenticationService: AuthenticationService, private route: ActivatedRoute, private router: Router, private http: HttpClient, private message: NzMessageService, public apiBackendService: ApiBackendService, private storage: AngularFireStorage, private modal: NzModalService, private globals: Globals) {
    // redirect to home if not logged
    if (!this.authenticationService.currentUserValue) {
      this.router.navigate(["/login"]);
    }
    // else if(this.authenticationService.currentUserInfo.role != 'admin')
    // {
    //   this.router.navigate(['/']);
    // }
    this.userRole = this.authenticationService.currentUserInfo.role;
    this.apiUrl = this.authenticationService.apiUrl;
    this.apiUrl = this.authenticationService.apiUrl;
    this.currentUserInfo = this.authenticationService.currentUserInfo;
    this.authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
  }

  getProcess(id) {
    return this.http.get<Process[]>(this.apiUrl + "/process_file/" + id, {
      observe: "response",
    });
  }

  getFiles() {
    const filterQuery = new Object();
    filterQuery["searchDate"] = this.searchValueDate;
    filterQuery["searchUploadDate"] = this.searchUploadDate;
    filterQuery["searchMessage"] = this.searchValueMessage;
    filterQuery["searchName"] = this.searchValueName;
    filterQuery["searchProcessedName"] = this.searchValueProcessedName;
    filterQuery["searchEmail"] = this.searchValueEmail;
    filterQuery["searchNotite"] = this.searchValueNotite;

    this.loading = true;
    this.apiBackendService
      .getFilesPaginated(this.pageSize, this.pageIndex, filterQuery)
      .pipe()
      .subscribe((res) => {
        this.totalPages = res.body["total_pages"] * this.pageSize;
        this.loading = false;
        this.filesData = res.body["results"];
        this.filesDataToDisplay = res.body["results"];

        console.log(this.filesDataToDisplay);
      });
  }

  ngOnInit() {
    window.scrollTo(0, 0);

    this.apiBackendService
      .getErrorMessages()
      .pipe()
      .subscribe((res) => {
        this.errorMessages = res.body;
        // for (const o of res.body) {
        //   this.errorMessages.push(o);
        // }
        this.getFiles();
      });

    // this.apiBackendService
    //   .getTransactions()
    //   .pipe()
    //   .subscribe((res) => {
    //     const children: Array<{ label: string; value: string }> = [];
    //     for (const o of res.body) {
    //       this.totalBalante += o.balanceAmount;
    //     }
    //   });

    this.apiBackendService.getUserById(this.currentUser.id).subscribe((res: any) => {
      this.totalBalante += res.body.credit;
      this.unlimitedSubscription = res.body.unlimitedSubscription;
      this.subscriptionEndDate = res.body.subscriptionEndDate;
    });

    if (this.authenticationService.currentUserInfo.role == "admin") {
      this.searchSubject
        .pipe(
          debounceTime(300),
          distinctUntilChanged(),
          switchMap((searchTerm: string) => {
            this.isLoading = true;
            return this.apiBackendService.searchUsers(searchTerm);
          })
        )
        .subscribe({
          next: (res) => {
            const users = res.body.map((o) => ({
              label: o.email,
              value: o.id,
              firstName: o.firstName,
              lastName: o.lastName,
            }));
            this.listOfUsers = users;
            this.isLoading = false;
          },
          error: (error) => {
            console.error("Error fetching users:", error);
            this.isLoading = false;
          },
        });
    }
  }

  onSearch(searchTerm: string): void {
    this.searchSubject.next(searchTerm);
  }

  processFile(file) {
    const msgID = this.message.loading("Se procesează fişierul <b>" + file.file + "</b>", { nzDuration: 0 }).messageId;
    this.loading = true;
    this.getProcess(file.id)
      .pipe()
      .subscribe((res) => {
        this.message.remove(msgID);
        if (res.body["balanceProcessError"] == 1) {
          this.message.create("warning", res.body["balanceProcessMessage"]);
        } else {
          this.message.create("success", res.body["balanceProcessMessage"]);
        }

        this.getFiles();
      });
  }

  getDownloadUrl(file) {
    this.downloadURL = this.storage.ref(file.file).getDownloadURL();
    this.fileMarkedForDownload = file;
  }

  downloadFile() {
    this.downloadURL = undefined;
    this.fileMarkedForDownload = undefined;
  }

  toggleShowSelectUser(entryId) {
    this.showSelectUser = entryId;
  }

  toggleShowEditNotes(entryId) {
    this.showEditNotes = entryId;
    const index = this.filesData.findIndex((file) => file.IDBalanceProcessed.toString() === entryId.toString());
    this.notes = this.filesData[index].notes;
  }

  saveChangedUser(fileId) {
    const index = this.filesData.findIndex((file) => file.id.toString() === fileId.toString());

    if (!this.selectedUserDetails) {
      console.error("No user selected");
      return;
    }

    this.filesData[index].userFirstName = this.selectedUserDetails.firstName;
    this.filesData[index].userLastName = this.selectedUserDetails.lastName;

    this.showSelectUser = undefined;

    this.apiBackendService.updateFileUser(fileId, this.selectedUserDetails.value).subscribe((res) => {
      console.log("User updated successfully");
    });
  }

  saveNotes(fileId) {
    const index = this.filesData.findIndex((file) => file.id.toString() === fileId.toString());

    this.filesData[index].notes = this.notes;

    this.showEditNotes = undefined;
    let note = new Object();
    note["notes"] = this.notes;
    this.apiBackendService
      .updateFileNotes(fileId, note)
      .pipe()
      .subscribe((res) => { });
  }

  pageIndexChanged(e) {
    console.log("page index changed", e);
    this.pageIndex = e;
    this.getFiles();
  }
  pageSizeChanged(e) {
    console.log("page size changed", e);
    this.pageSize = e;
    this.getFiles();
  }

  searchBalante(): void {
    this.filesDataToDisplay = this.filesData.filter((item: Files) => item.file.toLowerCase().indexOf(this.searchValueBalante) !== -1);
  }

  searchMesaj(): void {
    this.filesDataToDisplay = this.filesData.filter((item: Files) => item.balanceProcessMessage.toLowerCase().indexOf(this.searchValueMessage) !== -1);
  }

  searchUser(): void {
    this.filesDataToDisplay = this.filesData.filter((item: Files) => item.userFirstName.toLowerCase().indexOf(this.searchValueName) !== -1 || item.userLastName.toLowerCase().indexOf(this.searchValueName) !== -1);
  }

  searchEmail(): void {
    this.filesDataToDisplay = this.filesData.filter((item: Files) => item.userEmail.toLowerCase().indexOf(this.searchValueEmail) !== -1);
  }

  selectDate(e: any): void {
    var monthSelect = e.getMonth() + 1;
    var yearSelect = e.getFullYear();

    this.filesDataToDisplay = this.filesData.filter((item: Files) => item.month == monthSelect && item.year == yearSelect);
  }

  infoModal(tplContent: TemplateRef<{}>, tplFooter: TemplateRef<{}>, id: any): void {
    this.infoFile = this.filesDataToDisplay[id];

    this.modal.create({
      nzTitle: "Info file",
      nzContent: tplContent,
      nzClosable: false,
      nzFooter: tplFooter,
      nzComponentParams: {
        // value: 'Template Context'
      },
    });
  }

  toggleCompare(id) {
    // console.log("toggle", id);
    this.checkCompare = id;

    this.checkCompare.sort(function(a, b) {
      return a.month - b.month;
    });
    this.checkCompare.sort(function(a, b) {
      return a.year - b.year;
    });

    // console.log("toggle sort", id);
  }

  loadCompare() {
    console.log('loadCompare called, checkCompare:', this.checkCompare);
    this.globals.checkCompare = this.checkCompare;
    // Also store in localStorage for persistence across page refreshes
    localStorage.setItem("checkCompare", JSON.stringify(this.checkCompare));
    console.log('Saved to localStorage:', localStorage.getItem("checkCompare"));
    this.router.navigate(["/comparatii"]);
  }

  filterBy() {
    this.pageIndex = 1;
    this.getFiles();
  }

  fileVisible(id) {
    let visibleItemId = this.filesData.find((i) => i.id == id);
    visibleItemId.visible = visibleItemId.visible == 1 ? 0 : 1;

    this.apiBackendService
      .updateFileVisible(id)
      .pipe()
      .subscribe((res) => { });
  }

  openFile(reportType, file, language?: string) {
    localStorage.setItem("fileMonthYear", this.fullMonths[file.month] + " " + file.year);
    localStorage.setItem("fileMonth", this.fullMonths[file.month]);
    localStorage.setItem("fileYear", file.year);
    localStorage.setItem("fileMonthNumeric", file.month);
    localStorage.setItem("fileId", file.id.toString());
    console.log("Opening file - file.id:", file.id, "file.IDBalanceProcessed:", file.IDBalanceProcessed);
    let route = "";
    if (reportType == 0) {
      route = "/file";
    } else {
      route = "/file-s";
    }

    if (language) {
      route += `/${language}`;
    }

    this.router.navigate([route, file.IDBalanceProcessed]);
  }
  openDiagnostic(file) {
    this.router.navigate(["/diagnostic", file.IDBalanceProcessed]);
  }
  onSelectUser(selectedUserId: string | number): void {
    const user = this.listOfUsers.find((u) => u.value.toString() === selectedUserId.toString());

    if (user) {
      this.selectedUserDetails = user;
    } else {
      this.selectedUserDetails = null;
      console.warn("Selected user not found in the current list of users.");
    }
  }
}
